import { useState, useEffect } from "react";
import { Flex, Text } from "@radix-ui/themes";
import { MenuItem } from "components";
import { Outlet, useNavigate } from "react-router-dom";
import { useLocation } from "react-router-dom";
import { useProfileContext } from "context";
import { ClipboardDocumentListIcon, PresentationChartLineIcon, ChatBubbleBottomCenterTextIcon } from "@heroicons/react/24/outline";

export function SurveysLayout() {
  const navigate = useNavigate();
  const location = useLocation();
  const { userProfile } = useProfileContext();

  // Helper function to get menu state from path
  const getMenuStateFromPath = (path) => {
    if (path.includes("/surveys/analytics")) return "analytics";
    if (path.includes("/surveys/templates")) return "templates";
    if (path.includes("/surveys/responses")) return "responses";
    return "analytics"; // default path
  };

  // State to manage menu selection
  const [menuSelection, setMenuSelection] = useState(getMenuStateFromPath(location.pathname));

  // Function to handle menu selection
  const handleMenuSelection = (flag) => {
    setMenuSelection(flag);
    navigate(flag);
  };

  // Update menu selection on path change
  useEffect(() => {
    setMenuSelection(getMenuStateFromPath(location.pathname));
  }, [location.pathname]);

  return (
    <Flex direction="column" gap="5" height="100%" 
      style={{ alignSelf: "stretch", alignItems: "flex-start", flex: "1 0 0" }}>
        {/* Header */}
      {/* <Flex className="header-container" justify="center" align="end" gap="2" px="5" pt="5"
        style={{ alignSelf: "stretch", minHeight: "140px", background: "var(--color-background)" }}>
        <Flex gap="2" className="header-content" justify="between" style={{ flex: "1 0 0", alignItems: "center", 
          alignSelf: "stretch" }}>
          <Flex direction="column" gap="2" style={{ alignItems: "center", flex: "1 0 0", alignSelf: "stretch" }}>
            <Text weight="medium" size="5" align="center">Surveys</Text>
            <Text weight="medium" size="2" color="gray" align="center">
              Create and manage customer feedback surveys with customisable form blocks to gather insights from your visitors.
            </Text>
          </Flex>
        </Flex>
      </Flex> */}
      {/* Main content */}
      <Flex className="main-content-container" height="100%" gap="8" px="5" py="5"
          style={{ alignSelf: "stretch", flex: "1 0 0", alignItems: "flex-start" }}>
        <Flex className="main-content-sidebar-menu" width="144px" direction="column" gap="1" height="100%" 
          style={{ alignItems: "flex-start" }}>
          <MenuItem
            flag="analytics"
            state={menuSelection}
            onClick={handleMenuSelection} text="Analytics"
            tooltip="View analytics and insights on your surveys"
            icon={<PresentationChartLineIcon height={16} width={16} />}
          />
          <MenuItem
            flag="templates"
            state={menuSelection}
            onClick={handleMenuSelection}
            text="Templates"
            tooltip="Manage and customise your survey templates"
            icon={<ClipboardDocumentListIcon height={16} width={16} />}
          />
          <MenuItem
            flag="responses"
            state={menuSelection}
            onClick={handleMenuSelection}
            text="Responses"
            tooltip="View and analyse survey responses"
            icon={<ChatBubbleBottomCenterTextIcon height={16} width={16} />}
          />
        </Flex>
        <Flex style={{ alignSelf: "stretch", flex: "1 0 0", alignItems: "flex-start", height: "100%" }}>
          <Outlet />
        </Flex>
      </Flex>
    </Flex>
  );
}
